/**
 * Sesión de la tienda: quién es, en qué estado está la suscripción y cuál es el plan.
 *
 * No cambia mientras el comerciante usa la app, así que se pide una sola vez y se
 * comparte entre pantallas. De acá salen el precio, los días de prueba y los días de
 * retención del snapshot: la UI no los escribe en ningún lado.
 */

import { useEffect, useState } from 'react';
import { api, type Sesion } from './api';

let pedido: Promise<Sesion> | null = null;

export function cargarSesion(): Promise<Sesion> {
  // Si falló, se limpia la cache: el próximo render vuelve a intentar en vez de quedar
  // pegado a una promesa rechazada para siempre.
  pedido ??= api.sesion().catch((error: unknown) => {
    pedido = null;
    throw error;
  });
  return pedido;
}

/**
 * Devuelve `null` mientras carga y también si falla.
 *
 * Es deliberado: ninguna pantalla depende de la sesión para funcionar, sólo la usan para
 * textos informativos. Un fallo acá no puede tapar el historial ni el detalle.
 */
export function useSesion(): Sesion | null {
  const [sesion, setSesion] = useState<Sesion | null>(null);

  useEffect(() => {
    let vigente = true;
    cargarSesion()
      .then((valor) => {
        if (vigente) setSesion(valor);
      })
      .catch(() => undefined);
    return () => {
      vigente = false;
    };
  }, []);

  return sesion;
}
